import { InjectionToken } from '@angular/core';
import { JournalService, JournalStateStore } from './journal.interface';
import { JournalFactory } from './journal-factory.interface';
import { ActionHandler } from './action-handler.interface';

export const JOURNAL_SERVICE: InjectionToken<JournalService> = new InjectionToken('journal.service');

export const JOURNAL_FACTORY: InjectionToken<JournalFactory> = new InjectionToken('journal.factory');

export const JOURNAL_STATE_STORE = new InjectionToken<JournalStateStore>('journal.provider.state');

export const JOURNAL_ACTIONS_HANDLERS = new InjectionToken<ActionHandler>('journal.actions.handlers');
